(() => {
  function bindRelatedProductSlider(productSliderEl) {
    const slider = productSliderEl.sliderInstance?.slider;
    if (!slider) return false;

    const controls = productSliderEl.querySelector('.swiper-controls');
    if (!controls) return false;

    const nextEl = controls.querySelector('.swiper-button-next');
    const prevEl = controls.querySelector('.swiper-button-prev');
    const paginationEl = controls.querySelector('.swiper-pagination');

    if (nextEl && prevEl) {
      slider.params.navigation = slider.params.navigation || {};
      slider.params.navigation.nextEl = nextEl;
      slider.params.navigation.prevEl = prevEl;
      slider.navigation?.destroy?.();
      slider.navigation?.init?.();
      slider.navigation?.update?.();
    }

    if (paginationEl) {
      slider.params.pagination = slider.params.pagination || {};
      slider.params.pagination.el = paginationEl;
      slider.pagination?.destroy?.();
      slider.pagination?.init?.();
      slider.pagination?.render?.();
      slider.pagination?.update?.();
    }

    if (nextEl && !nextEl.dataset.relatedClickBound) {
      nextEl.dataset.relatedClickBound = 'true';
      nextEl.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        slider.slideNext();
      });
    }

    if (prevEl && !prevEl.dataset.relatedClickBound) {
      prevEl.dataset.relatedClickBound = 'true';
      prevEl.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        slider.slidePrev();
      });
    }

    return true;
  }

  function scheduleBind(rootEl) {
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const sliderEl = rootEl.querySelector('product-slider[data-enable-slider="true"]');
      if ((sliderEl && bindRelatedProductSlider(sliderEl)) || tries > 50) {
        clearInterval(timer);
      }
    }, 120);
  }

  function initRecommendationRoot(recommendationEl) {
    if (!recommendationEl || recommendationEl.dataset.relatedButtonsFixInit === 'true') return;
    recommendationEl.dataset.relatedButtonsFixInit = 'true';

    scheduleBind(recommendationEl);

    recommendationEl.addEventListener('recommendations:loaded', () => {
      scheduleBind(recommendationEl);
    });

    const observer = new MutationObserver(() => {
      scheduleBind(recommendationEl);
    });
    observer.observe(recommendationEl, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('product-recommendations.related-products').forEach((recommendationEl) => {
      initRecommendationRoot(recommendationEl);
    });
  }

  function handleDelegatedArrowClick(event) {
    const button = event.target.closest(
      '.section--related-products .swiper-button-next, .section--related-products .swiper-button-prev'
    );
    if (!button) return;

    const sliderEl = button.closest('product-slider');
    const slider = sliderEl?.sliderInstance?.slider;
    if (!slider) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.classList.contains('swiper-button-next')) {
      slider.slideNext();
    } else if (button.classList.contains('swiper-button-prev')) {
      slider.slidePrev();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', handleDelegatedArrowClick, true);
})();
